import React from 'react';

const Masthead = () => {
  return (
    <header className="bg-gradient-to-br from-blue-2 to-dark-2 text-white py-12 px-4 md:px-8 lg:px-16">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8">
        {/* Section texte */}
        <div className="flex-1 space-y-6">
          <h1 className="font-sans text-3xl md:text-4xl lg:text-title font-bold leading-tight">
            Un espace pour échanger, partager et grandir ensemble.
          </h1>
          <p className="font-sans text-normal md:text-lg text-light-3 leading-relaxed">
            Le <span className="font-bold">Forum NextMaker</span> est la place où la communauté s'exprime.
          </p>
          <p className="font-sans text-normal md:text-lg text-light-3 leading-relaxed">
            Ici, tu peux poser tes questions, partager tes découvertes, présenter tes projets ou simplement discuter avec d'autres passionnés de <span className="font-bold text-green-1">code</span>, <span className="font-bold text-purple-1">robotique</span>, <span className="font-bold text-blue-1">design</span> et <span className="font-bold text-red-4">fabrication numérique</span>.
          </p>
        </div>
        
        {/* Section illustration */}
        <div className="flex-1 flex justify-center">
          <div className="relative w-full max-w-md">
            {/* Illustration représentant des jeunes connectés */}
            <div className="relative w-full aspect-square bg-dark-5 rounded-2xl p-6">
              {/* Icônes représentant différents éléments technologiques */}
              <div className="absolute top-1/4 left-1/4 w-16 h-16 md:w-20 md:h-20 bg-purple-1 rounded-full flex items-center justify-center">
                <svg className="w-8 h-8 md:w-10 md:h-10" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"/>
                </svg>
              </div>
              
              <div className="absolute top-1/3 right-1/4 w-12 h-12 md:w-16 md:h-16 bg-blue-1 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 md:w-8 md:h-8" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14z"/>
                </svg>
              </div>
              
              <div className="absolute bottom-1/4 left-1/3 w-14 h-14 md:w-18 md:h-18 bg-red-4 rounded-full flex items-center justify-center">
                <svg className="w-8 h-8 md:w-10 md:h-10" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M5 20v-8H2l10-9 10 9h-3v8H5zm7-14.31l-5 4.5V18h10v-7.81l-5-4.5z"/>
                </svg>
              </div>
              
              <div className="absolute bottom-1/3 right-1/4 w-12 h-12 md:w-16 md:h-16 bg-green-1 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 md:w-8 md:h-8" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z"/>
                </svg>
              </div>
              
              {/* Lignes de connexion entre les éléments */}
              <svg className="absolute inset-0 w-full h-full" viewBox="0 0 100 100">
                <line x1="25" y1="25" x2="40" y2="40" stroke="#6440FB" strokeWidth="0.5" />
                <line x1="75" y1="33" x2="60" y2="45" stroke="#5347EB" strokeWidth="0.5" />
                <line x1="33" y1="75" x2="45" y2="60" stroke="#F94A56" strokeWidth="0.5" />
                <line x1="67" y1="67" x2="75" y2="75" stroke="#00FF84" strokeWidth="0.5" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Masthead;